import React from "react";
import "./HelpSection.css";

export const ProfileLogo:React.FC<{profile: string, additionalStyles?: {} }> = ({profile, additionalStyles}) => <div className="helpers__profile" style={additionalStyles}>
  {profile}
</div>

const HelpSection: React.FC<{ imageSrc: string, title: string, profile?: string }> = ({ imageSrc, title, profile }) => {
  return <div className="helpers_container">
    <div className="helpers">
      {profile ? <ProfileLogo profile={profile} additionalStyles={{marginLeft: "-1.5%"}}/>:
        <img src={imageSrc} alt={imageSrc} />
      }
      <span>{title}</span>
    </div>
    {profile ? <p>...</p> : null}
  </div>
};

export default HelpSection;
